<msf-summary-wrapper
  title="{{ 'Crop monitoring' | translate }}"
  [items]="MENU_ITEMS | menuChildren:MenuItemType.CropMonitoring"
  leftSize="7"
  rightSize="5"
  [separator]="true">
  <div
    right
    #right>
    <div class="mt-4">
      <app-summary-info class="summary-info"></app-summary-info>
    </div>
  </div>
</msf-summary-wrapper>
